import React, {Component} from "react";

import { Navbar, Container, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Image, Text } from "@chakra-ui/react";
import { Icon } from '@chakra-ui/react'
import { FaTwitter } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';


export default class navbar extends Component {
    render() {
        return (
            <>
                <Navbar collapseOnSelect expand="lg" bg="trasparent" variant="dark" style={{position: "relative"}}>
                    <Container>
                    <Navbar.Brand >
                        <Image src={this.props.img} boxSize='120px' />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" color="white"/>
                    <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
                        <Nav className="justify-content-center">
                            <Nav.Link>
                                <Link to='/'>
                                    <Text style={{ fontFamily: "Roboto", fontSize:"25px"}} color={this.props.color} >HOME</Text>
                                </Link>
                            </Nav.Link>
                            <Nav.Link>
                                <Link to='/lore'>
                                <Text style={{ fontFamily: "Roboto", fontSize:"25px"}} color={this.props.color} >LORE</Text>
                                </Link>
                            </Nav.Link>
                            <Nav.Link>
                                <Link to='/thesandbox'>
                                <Text style={{ fontFamily: "Roboto", fontSize:"25px"}} color={this.props.color} >THE SANDBOX</Text>
                                </Link>
                            </Nav.Link>
                            <Nav.Link>
                                <Link to='/roadmap'>
                                <Text style={{ fontFamily: "Roboto", fontSize:"25px"}} color={this.props.color} >ROADMAP</Text>
                                </Link>
                            </Nav.Link>
                        </Nav>
                        <Nav className="justify-content-end">             
                            <Nav.Link href="https://twitter.com/CarnivalSociety">
                                <Icon color={this.props.color} as={FaTwitter}  w={10} h={10} />
                            </Nav.Link>
                            <Nav.Link href="https://www.instagram.com/the_carnival_society/">
                                <Icon color={this.props.color} as={FaInstagram}  w={10} h={10} />
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                    </Container>
                </Navbar> 
            </>
        );
    }
}